﻿/**
 * link-modal.controller
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.portal').controller('link-modal.controller', linkModalController);

	/** setup injection */
	linkModalController.$inject = ['$uibModalInstance', 'toastr', 'portal-link.repository', 'portal-link-role.repository', 'portal-link-location.repository', 'portal-link-group.repository', 'portal-link-group-link.repository', 'color.repository', 'config.repository', 'role.repository', 'role-type.repository', 'stateRepository', 'schoolService', 'portalLink', 'parentInit'];

	/** implementation */
	function linkModalController($uibModalInstance, toastr, portalLinkRepo, portalLinkRoleRepo, portalLinkLocationRepo, portalLinkGroupRepo, portalLinkGroupLinkRepo, colorRepo, configRepo, roleRepo, roleTypeRepo, stateRepository, schoolService, portalLink, parentInit) {
		/** pubic properties */
		var vm = this;
		vm.saving = false;
		vm.isNew = portalLink ? false : true;
		vm.tab = 'link-info-tab';
		vm.original = portalLink || createPortalLink();
		vm.portalLink = angular.copy(vm.original);
		vm.colors = [];
		vm.allSettings = [];
		vm.selectedSetting = null;
		vm.linkType = portalLink && portalLink.settingKey !== null && portalLink.settingKey.length > 0 ? 2 : 1;
		vm.linkTypes = [{ 'label': 'External Link', 'value': 1 }, { 'label': 'Portal Setting', 'value': 2 }];
		vm.iconType = null;
		vm.iconTypes = [{ 'label': 'Icon Class', 'value': 1 }, { 'label': '3 Letter Icon', 'value': 2 }, { 'label': 'SVG', 'value': 3 }];
		vm.isRequired = {
			'url': (vm.linkType === 1 ? true : false),
			'portalSetting': (vm.linkType === 2 ? true : false)
		};

		/** public properties (portalLinkRoles) */
		vm.portalLinkRoles = [];
		vm.selectedRole = null;
		vm.roles = [];
		vm.selectedRoleType = null;
		vm.roleTypes = [];

		/** public properties (portalLinkLocations) */
		vm.portalLinkLocations = [];
		vm.selectedLocationType = null;
		vm.locationTypes = [
			{ 'label': 'Service Center', 'value': 1 },
			{ 'label': 'All NHA Schools', 'value': 2 },
			{ 'label': 'Select Schools', 'value': 3 }
		];
		vm.selectedState = null;
		vm.states = [];
		vm.selectedSchool = null;
		vm.allSchools = [];
		vm.schools = [];

		/** public properties (portalLinkGroupLinks) */
		vm.portalLinkGroupLinks = [];
		vm.portalLinkGroups = [];
		vm.selectedGroup = null;

		/** public methods (portalLink) */
		vm.save = save;
		vm.activate = activate;
		vm.remove = remove;
		vm.close = close;
		vm.cancel = cancel;
		vm.changeLinkType = changeLinkType;
		vm.changeIconType = changeIconType;

		/** public methods (portalLinkRole) */
		vm.addRole = addRole;
		vm.removeRole = removeRole;

		/** public methods (portalLinkLocations) */
		vm.locationMessage = null;
		vm.disableLocationAddBtn = disableLocationAddBtn;
		vm.getSchoolOptions = getSchoolOptions;
		vm.addLocation = addLocation;
		vm.removeLocation = removeLocation;

		/** public methods (portalLinkGroupLinks) */
		vm.addGroup = addGroup;
		vm.removeGroup = removeGroup;

		/** run init */
		init();

		/** public method implementations */

		/** save the link */
		function save() {
			/** flip saving flag */
			vm.saving = true;

			/** map values from source to original */
			_.merge(vm.original, vm.portalLink);

			/** check for portal setting */
			if (vm.linkType === 2 && vm.selectedSetting) {
				vm.original.settingKey = vm.selectedSetting.settingKey;
			}

			/** send the request to activate/deactivate */
			portalLinkRepo.save(vm.original, (vm.original.portalLinkID !== 0 ? vm.original.portalLinkID : undefined)).then(function(newPortalLink) {
				/** show the success message */
				swal({
					'title': 'Save Complete',
					'text': 'The processing has completed. The link was saved successfully.',
					'type': 'success'
				}, function() {
					/** flip saving flag */
					vm.saving = false;

					/** set isNew to false */
					vm.isNew = false;
					
					/** set original and copy */
					if (newPortalLink) {
						portalLink = newPortalLink;
						vm.original = newPortalLink;
						vm.portalLink = angular.copy(vm.original);
					}

					/** reinitialize the parent */
					parentInit();

					/** load the support data */
					loadSupportData();
				});
			});
		}

		/** activate/deactivate a link */
		function activate(active) {
			/** set the isEnabled flag */
			vm.original.isEnabled = active;

			/** flip saving flag */
			vm.saving = true;

			/** send the request to activate/deactivate */
			portalLinkRepo.put(vm.original, vm.original.portalLinkID).then(function() {
				/** flip the isEnabled flag on the copy */
				vm.portalLink.isEnabled = vm.original.isEnabled;

				/** flip saving flag */
				vm.saving = false;

				/** show the success message */
				swal({
					'title': 'Save Complete',
					'text': 'The processing has completed. The link was saved successfully.',
					'type': 'success'
				}, function() {
					/** reinitialize the parent */
					parentInit();
				});
			});
		}

		/** remove the link */
		function remove() {
			/** show swal confirmation window */
			swal({
				'title': 'Are you sure you want to delete this link?',
				'type': 'warning',
				'showCancelButton': true,
				'confirmButtonText': 'Yes, Delete It!',
				'closeOnConfirm': false
			}, function(isConfirm) {
				/** check the isConfirm flag */
				if (isConfirm) {
					/** flip saving flag */
					vm.saving = true;

					/** send the request to activate/deactivate */
					portalLinkRepo.remove(portalLink.portalLinkID).then(function() {
						/** flip saving flag */
						vm.saving = false;

						/** show the success message */
						swal({
							'title': 'Delete Complete',
							'text': 'The processing has completed. The link was deleted successfully.',
							'type': 'success'
						}, function() {
							/** reinitialize the parent */
							parentInit();

							/** close modal */
							close();
						});
					});
				}
			});
		}

		/** close the modal */
		function close() {
			$uibModalInstance.close();
		}

		/** cancel the modal */
		function cancel() {
			$uibModalInstance.dismiss();
		}

		/** change the data based on the link type */
		function changeLinkType() {
			vm.selectedSetting = null;

			/** change the data for the selected type */
			if (vm.linkType === 1) { // external link
				vm.portalLink.settingKey = null;
				vm.isRequired.url = true;
				vm.isRequired.portalSetting = false;
			}
			if (vm.linkType === 2) { // portal setting
				vm.portalLink.url = null;
				vm.isRequired.url = false;
				vm.isRequired.portalSetting = true;
			}
		}

		/** change the icon type for the link */
		function changeIconType() {
			if (vm.iconType === 1) { // icon class
				vm.portalLink.iconLetters = null;
				vm.portalLink.iconSVG = null;
			}
			if (vm.iconType === 2) { // icon letters
				vm.portalLink.iconClass = null;
				vm.portalLink.iconSVG = null;
			}
			if (vm.iconType === 3) { // icon svg
				vm.portalLink.iconClass = null;
				vm.portalLink.iconLetters = null;
			}
		}

		/** add a portalLinkRole */
		function addRole() {
			/** create the portalLinkRole object */
			var newPortalLinkRole = {
				'portalLinkRoleID': 0,
				'portalLinkID': vm.portalLink.portalLinkID,
				'roleID': vm.selectedRole
			};

			/** add the role */
			portalLinkRoleRepo.save(newPortalLinkRole).then(function() {
				/** reload portalLinkRoles */
				loadPortalLinkRoles();

				/** show success message */
				toastr.success('Role added successfully.', 'Save Successful', { positionClass: 'toast-bottom-right' });

				/** reset selected role type and role */
				vm.selectedRole = null;
				vm.selectedRoleType = null;
			});
		}

		/** remove a portalLinkRole */
		function removeRole(portalLinkRole) {
			/** send the request */
			portalLinkRoleRepo.remove(portalLinkRole.portalLinkRoleID).then(function() {
				/** remove record from portalLinkRoles */
				vm.portalLinkRoles = vm.portalLinkRoles.filter(function(plr){ return plr.portalLinkRoleID !== portalLinkRole.portalLinkRoleID; });

				/** show success message */
				toastr.success('Role removed successfully.', 'Removal Successful', { positionClass: 'toast-bottom-right' });
			});
		}

		/** check whether the add location button should be disabled */
		function disableLocationAddBtn() {
			/** haven't selected a location type yet */
			if (vm.selectedLocationType === null) return true;

			/** reset the location message */
			vm.locationMessage = null;

			/** trying to add service center */
			if (vm.selectedLocationType === 1) {
				/** check to see if service center already exists */
				if (vm.portalLinkLocations.filter(function(pll){ return pll.isServiceCenter; }).length > 0) {
					vm.locationMessage = 'The Service Center has already been set has a location.';
					return true;
				}

				/** do not disable */
				return false;
			}

			/** trying to add all schools */
			if (vm.selectedLocationType === 2) {
				/** check to see if all schools record already exists, or an individual school record exists */
				if (vm.portalLinkLocations.filter(function(pll){ return pll.isAllSchools || pll.schoolID !== null; }).length > 0) {
					vm.locationMessage = 'There is already an All NHA Schools record -OR- individual schools have been chosen.';
					return true;
				}

				/** do not disable */
				return false;
			}

			/** trying to add individual school and All Schools already selected */
			if (vm.selectedLocationType === 3) {
				/** check to see if the school record already exists */
				if (vm.portalLinkLocations.filter(function(pll){ return pll.isAllSchools; }).length > 0) {
					vm.locationMessage = 'There is already an All NHA Schools record.';
					return true;
				}

				/** check for selected state */
				if (vm.selectedState !== null && vm.selectedSchool !== null) {
					/** do not disable */
					return false;
				}
			}

			/** return true as default */
			return true;
		}

		/** get the school options based upon the state */
		function getSchoolOptions() {
			/** reset the schools */
			vm.schools = [];

			/** return if no state selected */
			if (vm.selectedState === null) return;

			/** get school ids */
			var schoolIDs = _.map(vm.portalLinkLocations.filter(function(pll) {
				return pll.schoolID !== null && pll.school.stateID === vm.selectedState;
			}), function(pll) {
				return pll.schoolID;
			});

			/** get the schools for the selected state */
			vm.schools = vm.allSchools.filter(function(sc) {
				return sc.stateID === vm.selectedState && !schoolIDs.contains(sc.schoolID);
			});
			vm.schools.sort(function(a, b) {
				if (a.schoolName < b.schoolName) return -1;
				if (a.schoolName > b.schoolName) return 1;
				return 0;
			});

			/** check if all schools option is necessary */
			if (vm.portalLinkLocations.filter(function(pll){ return pll.stateID === vm.selectedState; }).length === 0) {
				/** get the state */
				var state = vm.states.filter(function(st) {
					return st.stateID === vm.selectedState;
				})[0];

				/** add an all schools option */
				vm.schools.unshift({ 'schoolID': -1, 'schoolName': 'All ' + state.name + ' Schools' });
			}
		}

		/** add a location record */
		function addLocation() {
			/** create array */
			var newPortalLinkLocations = [];

			/** check for all schools option */
			if (vm.selectedLocationType === 3 && vm.selectedSchool === -1) {
				/** get school ids */
				var schoolIDs = _.map(vm.portalLinkLocations.filter(function(pll) {
					return pll.schoolID !== null && pll.school.stateID === vm.selectedState;
				}), function(pll) {
					return pll.schoolID;
				});

				/** add a record for the state */
				newPortalLinkLocations.push({
					'portalLinkLocationID': 0,
					'portalLinkID': vm.portalLink.portalLinkID,
					'isServiceCenter': false,
					'isAllSchools': false,
					'stateID': vm.selectedState,
					'schoolID': null
				});

				/** get all the schools for the selected state */
				_.forEach(vm.allSchools, function(sc) {
					if (sc.stateID === vm.selectedState && !schoolIDs.contains(sc.schoolID)) {
						newPortalLinkLocations.push({
							'portalLinkLocationID': 0,
							'portalLinkID': vm.portalLink.portalLinkID,
							'isServiceCenter': false,
							'isAllSchools': false,
							'schoolID': sc.schoolID
						});
					}
				});
			} else {
				/** create the portalLinkLocation object */
				newPortalLinkLocations.push({
					'portalLinkLocationID': 0,
					'portalLinkID': vm.portalLink.portalLinkID,
					'isServiceCenter': vm.selectedLocationType === 1,
					'isAllSchools': vm.selectedLocationType === 2,
					'schoolID': vm.selectedSchool
				});
			}

			/** add the location */
			portalLinkLocationRepo.postAll(newPortalLinkLocations).then(function() {
				/** reload portalLinkLocations */
				loadPortalLinkLocations().then(function() {
					/** show success message */
					toastr.success('Location added successfully.', 'Save Successful', { positionClass: 'toast-bottom-right' });

					/** reset selectors */
					if (vm.selectedLocationType !== 3) {
						vm.selectedLocationType = null;
						vm.selectedState = null;
						vm.selectedSchool = null;
					}
					if (vm.selectedLocationType === 3) {
						vm.selectedSchool = null;
						getSchoolOptions();
					}
				});
			});
		}

		/** remove a location record */
		function removeLocation(portalLinkLocation) {
			/** send the request */
			portalLinkLocationRepo.remove(portalLinkLocation.portalLinkLocationID).then(function() {
				/** reload portalLinkLocations */
				loadPortalLinkLocations().then(function() {
					/** show success message */
					toastr.success('Location removed successfully.', 'Removal Successful', { positionClass: 'toast-bottom-right' });

					/** reset selectors */
					if (vm.selectedLocationType === 3) {
						getSchoolOptions();
					}
				});
			});
		}

		/** add a new portalLinkGroupLink record */
		function addGroup() {
			/** create the portalLinkGroupLink object */
			var newPortalLinkGroupLink = {
				'portalLinkGroupLinkID': 0,
				'portalLinkID': vm.portalLink.portalLinkID,
				'portalLinkGroupID': vm.selectedGroup,
				'orderNumber': 1000
			};

			/** add the group */
			portalLinkGroupLinkRepo.save(newPortalLinkGroupLink).then(function() {
				/** reload portalLinkGroupLinks */
				loadPortalLinkGroupsLinks().then(function() {
					/** adjust the available groups */
					adjustPortalLinkGroups();
				});

				/** show success message */
				toastr.success('Group added successfully.', 'Save Successful', { positionClass: 'toast-bottom-right' });

				/** reset selected group */
				vm.selectedGroup = null;
			});
		}

		/** remove a portalLinkGroupLink record */
		function removeGroup(portalLinkGroupLink) {
			/** send the request */
			portalLinkGroupLinkRepo.remove(portalLinkGroupLink.portalLinkGroupLinkID).then(function() {
				/** remove record from portalLinkGroupLinks */
				vm.portalLinkGroupLinks = vm.portalLinkGroupLinks.filter(function(plgl){ return plgl.portalLinkGroupLinkID !== portalLinkGroupLink.portalLinkGroupLinkID; });

				/** adjust the available groups */
				adjustPortalLinkGroups();

				/** show success message */
				toastr.success('Group removed successfully.', 'Removal Successful', { positionClass: 'toast-bottom-right' });
			});
		}

		/** private methods */

		/** initialize */
		function init() {
			/** load the possible colors */
			colorRepo.getAll().then(function(colors) {
				/** set the colors */
				vm.colors = colors;
			});

			/** get the distinct settings keys */
			configRepo.getSettings().then(function (settings) {
				/** set allSettings */
				vm.allSettings = settings;

				/** check to see if selectedSetting needs to be set */
				if (vm.original.settingKey !== null) {
					vm.selectedSetting = vm.allSettings.find(function (s) {
						return s.settingKey === vm.original.settingKey;
					});
				}
			});

			/** set the iconType */
			if (vm.portalLink.iconClass && vm.portalLink.iconClass.length > 0) vm.iconType = 1;
			if (vm.portalLink.iconLetters && vm.portalLink.iconLetters.length > 0) vm.iconType = 2;
			if (vm.portalLink.iconSVG && vm.portalLink.iconSVG.length > 0) vm.iconType = 3;

			/** load the portal link roles if not new */
			if (!vm.isNew) {
				/** load the support data */
				loadSupportData();
			}

			/** set focus on the */
			$uibModalInstance.rendered.then(function() {
				$('.modal-body div input[type="text"]:first').focus();
			});
		}

		/** load roles, locations, and groups */
		function loadSupportData() {
			/** load the role types */
			roleTypeRepo.getAll().then(function(roleTypes) {
				/** set the role types */
				vm.roleTypes = roleTypes;

				/** load the roles */
				roleRepo.getAll().then(function(roles) {
					/** set the roles */
					vm.roles = roles;

					/** load the portal link roles */
					loadPortalLinkRoles();
				});
			});

			/** load schools */
			schoolService.getSchools().then(function(schools) {
				/** set the schools */
				vm.allSchools = schools;

				/** get the state ids to filter states */
				var stateIDs = _.map(vm.allSchools, function(sc) {
					return sc.stateID;
				});

				/** load states */
				stateRepository.getAll().then(function(states) {
					/** filter states */
					states = states.filter(function(st) {
						return stateIDs.contains(st.stateID);
					});

					/** set the states */
					vm.states = states;

					/** load portal link locations */
					loadPortalLinkLocations();
				});
			});

			/** load the portalLinkGroupLinks */
			loadPortalLinkGroupsLinks().then(function() {
				/** load portal link groups */
				portalLinkGroupRepo.getAll().then(function(portalLinkGroups) {
					/** strip html and add visible flag */
					_.forEach(portalLinkGroups, function(plg) {
						plg.portalLinkGroupName = plg.portalLinkGroupName.stripHtml();
						plg.visible = true;
					});

					/** set groups and adjust */
					vm.portalLinkGroups = portalLinkGroups;
					adjustPortalLinkGroups();
				});
			});
		}

		/** load the portal link roles */
		function loadPortalLinkRoles() {
			portalLinkRoleRepo.getAll({ 'filter': { 'PortalLinkID': vm.original.portalLinkID }, 'orderby': 'Role/RoleName' }).then(function(portalLinkRoles) {
				/** set value */
				vm.portalLinkRoles = portalLinkRoles;
			});
		}

		/** load the portal link location records */
		function loadPortalLinkLocations() {
			return portalLinkLocationRepo.getAll({ 'filter': { 'PortalLinkID': vm.original.portalLinkID }, 'orderby': 'IsServiceCenter,IsAllSchools,State/Name,School/SchoolName' }).then(function(portalLinkLocations) {
				/** add the schools state name */
				_.forEach(portalLinkLocations.filter(function(pll) {
					return pll.schoolID !== null;
				}), function(pll) {
					pll.school.stateName = getStateName(pll.school.stateID);
				});

				/** set value */
				vm.portalLinkLocations = portalLinkLocations;
			});
		}

		/** load the portal link group links */
		function loadPortalLinkGroupsLinks() {
			return portalLinkGroupLinkRepo.getAll({ 'filter': { 'PortalLinkID': vm.original.portalLinkID }, 'orderby': 'PortalLinkGroup/PortalLinkGroupName' }).then(function(portalLinkGroupLinks) {
				/** set value */
				vm.portalLinkGroupLinks = portalLinkGroupLinks;
			});
		}

		/** adjust the portal link groups */
		function adjustPortalLinkGroups() {
			/** filter out groups where this link already exists */
			var groupIDs = _.map(vm.portalLinkGroupLinks, function(plgl) {
				return plgl.portalLinkGroupID;
			});

			/** show/hide */
			_.forEach(vm.portalLinkGroups, function(plg) {
				plg.visible = !groupIDs.contains(plg.portalLinkGroupID);
			});
		}

		/** return a state name for the given state id */
		function getStateName(stateID) {
			/** find the matching state */
			var state = vm.states.filter(function(st) {
				return st.stateID === stateID;
			});

			/** check for match and return */
			if (state.length > 0) {
				return state[0].name;
			}

			/** return a blank name */
			return '';
		}

		/** create an empty PortalLink entity */
		function createPortalLink() {
			return {
				'portalLinkID': 0,
				'portalLinkName': 'New Link',
				'description': null,
				'url': null,
				'settingKey': null,
				'iconClass': 'nha-portal',
				'iconLetters': null,
				'iconSVG': null,
				'iconColor': '#7A8599',
				'isEnabled': false,
				'isMobile': false,
				'isRemoveable': true
			};
		}
	}
})();